import { getAvatarCategories } from './get-avatar-categories';

const AvatarService = {
  getAvatarCategories,
};

export default AvatarService;
